import {UI} from "../../../../../../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../../../../../../stem-core/src/ui/Style";
import {PopupMenu} from "../../../../../../ui/PopupMenu.jsx";
import {Messages} from "../../../../../../Messages";
import {registerStyle} from "../../../../../../../stem-core/src/ui/style/Theme";
import {EditAddressModal} from "./EditAddressModal";
import {DeleteAddressModal} from "./DeleteAddressModal";
import {AddressInUseModal} from "./AddressInUseModal";
import {SubscriptionStore} from "../../../../../../../client/state/SubscriptionStore";
import {isPlainObject} from "../../../../../../../stem-core/src/base/Utils.js";


class AddressListItemStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
        overflow: "initial !important",
    };

    @styleRule
    addressLine = {
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
    }
}

@registerStyle(AddressListItemStyle)
export class AddressListItem extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            address: null,
        }
    }

    promptAddressInUse(address) {
        AddressInUseModal.show({address});
    }

    // Returns the address only if it's not being used anywhere else
    selectAddressForChange() {
        const {address} = this.options;
        if (SubscriptionStore.getActiveWithAddress(address).length) {
            this.promptAddressInUse(address);
            return null;
        }

        return address;
    }

    promptEdit(address) {
        EditAddressModal.show({address});
    }

    promptDelete(address) {
        DeleteAddressModal.show({address});
    }

    getMenuItems({allowEdit = true, allowDelete = true} = {}) {
        return [
            allowEdit && {
                content: Messages.edit,
                onClick: () => {
                    const address = this.selectAddressForChange();
                    if (address) {
                        this.promptEdit(address);
                    }
                },
            },
            allowDelete && {
                content: Messages.deleteMessage,
                onClick: () => {
                    const address = this.selectAddressForChange();
                    if (address) {
                        this.promptDelete(address);
                    }
                },
            }].filter(isPlainObject);
    }

    render() {
        const {address} = this.options;

        return [
            <span className={this.styleSheet.addressLine}>{address}</span>,
            <PopupMenu items={this.getMenuItems()}/>
        ]
    }
}
